module.exports = __webpack_public_path__ + "static/media/1_WIP_RetailLab-264_V2 1.7b9ed604.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/converseValues/1_WIP_RetailLab-264_V2 1.png
// module id = 690
// module chunks = 0